module.exports = __webpack_public_path__ + "96ba87173e93e9337f29ebfa57a47023.png";